"use strict";Object.defineProperty(exports, "__esModule", {value: true});// The most files one send can carry: the web tray, the mobile picker and the
// server's SendMessageToConversation.Attachments validation all use 20.
 const MAX_ATTACHMENTS_PER_SEND = 20; exports.MAX_ATTACHMENTS_PER_SEND = MAX_ATTACHMENTS_PER_SEND
